export default __webpack_public_path__ + "static/media/Microsites.d3e0de90.png";